import { React, useEffect, useState, useCallback } from 'react';
import { useTranslation } from "react-i18next";
import { motion } from 'framer-motion';

import SkeletonLoader from "../../components/ui/SkeletonLoader/index.js";

import SideNav from "../../components/PostLogin/SideNav";
import ScanHistoryTab from "../../components/PostLogin/UserDetails/ScanHistory/index.js";

import { formatNumber } from "../../utils/util.js";

import { useSelector, useDispatch } from 'react-redux';
import { getDomainStats } from '../../store/actions/domainAction.js';

const ScanHistoryPage = () => {

    const domainStatusResponse = useSelector((state) => state.domain?.domainStatusResponse);   

    const { t } = useTranslation();

    const dispatch = useDispatch();
    
    const [isStatsLoading, setIsStatsLoading] = useState(false);    

    const fetchScanQueueStats = useCallback(()=>{
        setIsStatsLoading(true);
        dispatch(getDomainStats());
    },[dispatch])    

    useEffect(()=>{
        fetchScanQueueStats()
    },[fetchScanQueueStats])

    useEffect(()=>{
        if(domainStatusResponse !== null) {
            setIsStatsLoading(false)
        }
    },[domainStatusResponse])

    return (
        <div className="organization-details-container">
            <SideNav />
            <div className="organization-page-container">
                <div className="page-header-container px-4 py-3 d-flex align-items-center justify-content-between">
                    <div className="header-left d-flex align-items-center gap-3">
                        <h1>Scan History</h1>
                    </div>
                </div>
                <div className="page-main-section px-4 py-3">
                    <div className="organization-header-container p-3 my-3 rounded">
                        <div className="d-flex gap-3">
                            <div className="total-score-container rounded scan-queue-count">
                                {
                                    isStatsLoading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage="scanQueue" />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <div className="users-totol-count d-flex">
                                            <p className="total-user-count">{formatNumber(domainStatusResponse?.scans?.total)}</p>
                                            <div className="user-count mx-3 mt-2">
                                                <span className="active d-inline-block mx-1"></span>
                                                <span className="disbled d-inline-block"></span>
                                                <p>{t("scanQueuePage.scans")}</p>
                                            </div>
                                        </div>
                                        <div className="active-disabled-count d-flex gap-3">
                                            <p className="active-user"><span className="d-inline-block">{formatNumber(domainStatusResponse?.scans?.active)}</span> {t("scanQueuePage.activeScans")}</p>
                                            <p className="disabled-user"><span className="d-inline-block">{formatNumber(domainStatusResponse?.scans?.passive)}</span> {t("scanQueuePage.passiveScans")}</p>
                                        </div>
                                    </motion.div>
                                }                                
                            </div>
                        </div>
                    </div>
                    <div className="organization-main-container p-3">
                        <ScanHistoryTab currentPageType="scanHistoryPage"/>
                    </div>                    
                </div>
            </div>
        </div>
    )
}

export default ScanHistoryPage;